module.exports = __webpack_public_path__ + "static/media/job.74513f26.svg";